import Vue from 'vue'
import Router from 'vue-router'

//首页
import Home from '@/components/Home/Home'
import OrderFortune from '@/components/Home/OrderFortune'

//动态
import Trends from '@/components/Trends/Trends'
import SendTrends from '@/components/Trends/SendTrends'
import TrendDetail from '@/components/Trends/TrendDetail'
import TreeHoleDetail from '@/components/Trends/TreeHoleDetail'
import SendTreeHole from '@/components/Trends/SendTreeHole'
import TrendNotice from '@/components/Trends/TrendNotice'
import CommentList from '@/components/Trends/CommentList'
import GoodList from '@/components/Trends/GoodList'
import RewardList from '@/components/Trends/RewardList'

//消息
import Chats from '@/components/Chats/Chats'
import FriendList from '@/components/Chats/FriendList'
import Chatting from '@/components/Chats/Chatting'
import AddFriend from '@/components/Chats/AddFriend'
import FriendPage from '@/components/Chats/FriendPage'

//发现
import Finds from '@/components/Finds/Finds'
import AppointmentList from '@/components/Finds/AppointmentList'
import MyAppointment from '@/components/Finds/MyAppointment'
import AppointmentMine from '@/components/Finds/AppointmentMine'
import AppointAddGift from '@/components/Finds/AppointAddGift'
import AppointAddGiftCul from '@/components/Finds/AppointAddGiftCul'
import AppointmentOther from '@/components/Finds/AppointmentOther'
import SendAppointment from '@/components/Finds/SendAppointment'
import ActivityList from '@/components/Finds/ActivityList'
import MyActivityList from '@/components/Finds/MyActivityList'
import ActivityDetail from '@/components/Finds/ActivityDetail'
import JoinActivity from '@/components/Finds/JoinActivity'
import SendEditInfo from '@/components/Finds/SendEditInfo'

//我的
import Mine from '@/components/Mine/Mine'
import MyIntegral from '@/components/Mine/MyIntegral'
import MyIntegralDetail from '@/components/Mine/MyIntegralDetail'
import MyWallet from '@/components/Mine/MyWallet'
import MyWalletDetail from '@/components/Mine/MyWalletDetail'
import MyCertification from '@/components/Mine/MyCertification'
import MySetting from '@/components/Mine/MySetting'
import CertiName from '@/components/Mine/CertiName'
import CertiEdu from '@/components/Mine/CertiEdu'
import CertiHouse from '@/components/Mine/CertiHouse'
import CertiCar from '@/components/Mine/CertiCar'
import MyQuestion from '@/components/Mine/MyQuestion'
import MyLike from '@/components/Mine/MyLike'
import MyVisitor from '@/components/Mine/MyVisitor'
import MyGifts from '@/components/Mine/MyGifts'
import GiftExchange from '@/components/Mine/GiftExchange'
import GiftCash from '@/components/Mine/GiftCash'
import GiftAllCash from '@/components/Mine/GiftAllCash'
import Login from '@/components/Mine/Login'
import Register from '@/components/Mine/Register'
import MyPageMine from '@/components/Mine/MyPageMine'
import MyPageOther from '@/components/Mine/MyPageOther'
import VipCenter from '@/components/Mine/VipCenter'
import VipDetail from '@/components/Mine/VipDetail'
import AccountSafe from '@/components/Mine/AccountSafe'
import FeedBack from '@/components/Mine/FeedBack'
import EditPersonalInfo from '@/components/Mine/EditPersonalInfo'

//通用
import ChooseAddress from '@/components/Common/ChooseAddress'
import UserAgreement from '@/components/Common/UserAgreement'
import AboutUs from '@/components/Common/AboutUs'

//404
import NoResult from '@/components/Common/404'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		//home
		{path:'/',redirect:{name:'home'}},
		{path:'/home',name:'home',component:Home},
		{path:'/order-fortune',name:'order-fortune',component:OrderFortune},
		
		//动态
		{path:'/trends',name:'trends',component:Trends},
		{path:'/send-trends',name:'send-trends',component:SendTrends},
		{path:'/trend-detail',name:'trend-detail',component:TrendDetail},
		{path:'/send-edit-info',name:'send-edit-info',component:SendEditInfo},
		{path:'/tree-hole-detail',name:'tree-hole-detail',component:TreeHoleDetail},
		{path:'/send-tree-hole',name:'send-tree-hole',component:SendTreeHole},
		{path:'/trend-notice',name:'trend-notice',component:TrendNotice},
		
		//消息
		{path:'/chats',name:'chats',component:Chats},
		{path:'/friend-list',name:'friend-list',component:FriendList},
		{path:'/chatting',name:'chatting',component:Chatting},
		{path:'/add-friend',name:'add-friend',component:AddFriend},
		{path:'/friend-page',name:'friend-page',component:FriendPage},
		
		//发现
		{path:'/finds',name:'finds',component:Finds},
		{path:'/appointment-list',name:'appointment-list',component:AppointmentList},
		{path:'/my-appointment',name:'my-appointment',component:MyAppointment},
		{path:'/appointment-mine',name:'appointment-mine',component:AppointmentMine},
		{path:'/appoint-add-gift',name:'add-gift',component:AppointAddGift},
		{path:'/appoint-add-gift-cul',name:'add-gift-cul',component:AppointAddGiftCul},
		{path:'/appointment-other',name:'appointment-other',component:AppointmentOther},
		{path:'/send-appointment',name:'send-appointment',component:SendAppointment},
		{path:'/activity-list',name:'activity-list',component:ActivityList},
		{path:'/my-activity-list',name:'my-activity-list',component:MyActivityList},
		{path:'/activity-detail',name:'activity-detail',component:ActivityDetail},
		{path:'/join-activity',name:'join-activity',component:JoinActivity},
		
		//我的
		{path:'/mine',name:'mine',component:Mine},
		{path:'/comment-list',name:'comment-list',component:CommentList},
		{path:'/good-list',name:'good-list',component:GoodList},
		{path:'/reward-list',name:'reward-list',component:RewardList},
		{path:'/my-integral',name:'my-integral',component:MyIntegral},
		{path:'/my-integral-detail',name:'my-integral-detail',component:MyIntegralDetail},
		{path:'/my-wallet',name:'my-wallet',component:MyWallet},
		{path:'/my-wallet-detail',name:'my-wallet-detail',component:MyWalletDetail},
		{path:'/my-certification',name:'my-certification',component:MyCertification},
		{path:'/my-setting',name:'my-setting',component:MySetting},
		{path:'/certi-name',name:'certi-name',component:CertiName},
		{path:'/certi-edu',name:'certi-edu',component:CertiEdu},
		{path:'/certi-house',name:'certi-house',component:CertiHouse},
		{path:'/certi-car',name:'certi-car',component:CertiCar},
		{path:'/my-question',name:'my-question',component:MyQuestion},
		{path:'/my-like',name:'my-like',component:MyLike},
		{path:'/my-visitor',name:'my-visitor',component:MyVisitor},
		{path:'/my-gifts',name:'my-gifts',component:MyGifts},
		{path:'/gift-exchange',name:'gift-exchange',component:GiftExchange},
		{path:'/gift-cash',name:'gift-cash',component:GiftCash},
		{path:'/gift-all-cash',name:'gift-all-cash',component:GiftAllCash},
		{path:'/login',name:'login',component:Login},
		{path:'/register',name:'register',component:Register},
		{path:'/my-page-mine',name:'my-page-mine',component:MyPageMine},
		{path:'/my-page-other',name:'my-page-other',component:MyPageOther},
		{path:'/vip-center',name:'vip-center',component:VipCenter},
		{path:'/vip-detail',name:'vip-detail',component:VipDetail},
		{path:'/account-safe',name:'account-safe',component:AccountSafe},
		{path:'/feedback',name:'feedback',component:FeedBack},
		{path:'/edit-personal-info',name:'edit-personal-info',component:EditPersonalInfo},
		
		//通用
		{path:'/choose-address',name:'choose-address',component:ChooseAddress},
		{path:'/user-agreement',name:'user-agreement',component:UserAgreement},
		{path:'/about-us',name:'about-us',component:AboutUs},
		
		//404
		{path:'*',name:'no-result',component:NoResult}

	],
	beforeEach: (to, from, next) => {
		console.log(to, from);
		next();
	}
})


// WEBPACK FOOTER //
// ./src/router/index.js